<template>
  <div class="card card-plain">
    <div class="pb-0 card-header text-start">
      <h4 class="font-weight-bolder" style="color: #0385F3;">Daftar</h4>
      <p class="mb-0">Masukan data yang sesuai</p>
    </div>
    <div class="card-body">
      <form @submit.prevent="submit()">
        <div class="mb-3">
          <FormGroup>
            <InputForm type="text" v-model="form.nip" name="nip" placeholder="NIP" />
          </FormGroup>
        </div>
        <div class="mb-3">
          <FormGroup>
            <InputForm type="email" v-model="form.email" name="email" placeholder="Email" />
          </FormGroup>
        </div>

        <div class="text-center">
          <argon-button class="mt-4" variant="gradient" fullWidth size="lg">DAFTAR</argon-button>
        </div>
      </form>
    </div>
    <div v-if="false" class="px-1 pt-0 text-center card-footer px-lg-2">
      <p class="mx-auto mb-4 text-sm">
        Sudah punya akun?
        <router-link :to="{ name: 'Signin' }" style="color: #6E7377;" class="font-weight-bold">Masuk</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import AuthApi from "../../repository/api/AuthApi";
import FormGroup from '../../components/FormGroup.vue';
import InputForm from '../../components/InputForm.vue';
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signup",
  components: {
    ArgonButton,
    FormGroup,
    InputForm,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    }
  },
  async mounted() {
    if (localStorage.getItem("token")) {
      await AuthApi.check_token({
        token: localStorage.getItem("token").toString(),
      }).then(() => {
        this.$router.push({ name: "Dashboard" });
      }).catch(() => {
        this.logout();
        localStorage.removeItem("token");
        this.$store.state.token = '';
      });
    }
  },
  methods: {
    async submit() {
      this.$store.state.loading = true;
      await AuthApi.register(this.form).then(async () => {
        this.$swal({
          icon: "success",
          title: "Success",
          text: "Silahkan cek email anda dan lakukan verifikasi akun"
        })
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error.response.data.message,
          confirmButtonText: (error?.response?.status ?? null) == 412 ? "Masuk" : "Ok",
          showCancelButton: (error?.response?.status ?? null) == 412
        }).then((result) => {
          switch (error?.response?.status ?? null) {
            case 412:
              if (result.isConfirmed) {
                this.$router.push({ name: "Signin" });
              }
              break;
          }
          this.form = {
            username: "",
            password: "",
          };
        });
      })
      this.$store.state.loading = false;
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
